// extracted by mini-css-extract-plugin
export default {"table":"ObjectiveStats_table__2oO30","searchbar":"ObjectiveStats_searchbar__sN3Km","sort":"ObjectiveStats_sort__RPta5"};